import axios from "axios"
import { $Q, $Qll } from "../utils/query-selector"
import { addNodeSpinner } from '../utils/spinner';
import api from "../services/api";

/**
 * Build payload object with form data (user data)
 * @param {node} form
 * @returns object
 * @author Daniel Santos
 */
export const buildObject = (form, typeInput = 'input') => {
  const payload = {}
  const inputs = $Qll(typeInput, form).length && $Qll(typeInput, form)

  for (let index = 0; index < inputs.length; index++) {
    const element = inputs[index];

    if (element.value) {
      if (element.type === 'checkbox') {
        payload[element.name] = element.checked
      } else {
        payload[element.name] = element.value
      }
    }
  }  return payload
}

/**
 * Validate API response and render feedback to user
 * @param {string} message - Response PI
 * @returns null - stop called
 * @author Daniel Santos
 */
const renderFeedback = (message) => {
  switch (message) {
    case 'We will be contacting you soon':
      const title = $Q('.description-modal__title:not(.success-message)')
      const descript = $Q('.description-modal__description:not(.success-message)')
      const form = $Q('#js-plus-photo-form')
      const componentFeedback = $Q('#js-photo-plus-response')

      if (!componentFeedback || !form) return;

      componentFeedback.removeAttribute('style')
      form.style.display = 'none'
      title.style.display = 'none'
      descript.style.display = 'none'
      break;

    case 'The telephone number must be in E.164 format, for example: +16136120707':
      const componentFeedbackError = $Q('#js-error-phone')

      if (!componentFeedbackError) return;
      componentFeedbackError.removeAttribute('style')
      break;

    default:
      const componentFeedbackErrorGeneral = $Q('#js-photo-plus-response-error')

      if (!componentFeedbackErrorGeneral) return;
      componentFeedbackErrorGeneral.removeAttribute('style')
      break;
  }
}

/**
 * Clean inputs
 * @author Daniel Santos
 */
export const cleanInputs = (form, submitBtn) => {
  form.length && form.forEach((el) => {
    if (el.type === 'checkbox') {
      el.checked = false
    } else if (el.value) {
      el.value = ''
    }
  })

  if (submitBtn) submitBtn.disabled = false
}

const hiddenElements = (element) => {
  if (!element) return;

  element.style.display = 'none'
}

/**
 * Restore message of user feedback
 * @param {boolean} error - To restore errors feedback or success feedback
 * @returns
 */
export const restoreFormMessage = (error) => {
  if (error) {
    const componentFeedbackError = $Q('#js-error-phone')
    const componentFeedbackErrorGeneral = $Q('#js-photo-plus-response-error')

    hiddenElements(componentFeedbackError)
    hiddenElements(componentFeedbackErrorGeneral)

  } else {
    const title = $Q('.description-modal__title:not(.success-message)')
    const descript = $Q('.description-modal__description:not(.success-message)')
    const componentFeedback = $Q('#js-photo-plus-response')
    const form = $Q('#js-plus-photo-form')

    if (!form) return;

    form.removeAttribute('style')

    if (!title) return;

    title.removeAttribute('style')

    if (!descript) return;

    descript.removeAttribute('style')
    hiddenElements(componentFeedback)
  }
}

const sendKlaviyoForm = () => {
  const klaviyoFormComponent = $Q('#js-klaviyo-plus-photo')

  if (!klaviyoFormComponent) return

  const input = $Q('input[type="email"]', klaviyoFormComponent)
  const btn = $Q('button[type="button"]', klaviyoFormComponent)

  if (!input || !btn) return

  const photoPlusForm = $Q('#js-plus-photo-form input[type="email"]').value
  const klaviyoForm = $Q('form.klaviyo-form', klaviyoFormComponent)
  input.value = photoPlusForm
  klaviyoForm.submit()
}

/**
 * Make submit to Vintega API
 * Get response API and
 * Render and remove loaders
 * Render feedbacks
 * @returns null - stop called
 * @author Daniel Santos
 */
export const submitPlusPhotos = () => {
  const form = $Q('#js-plus-photo-form')
  const submitBtn = $Q('#js-plus-photo-form button[type="submit"]')

  if (!form) return

  form.addEventListener('submit', async (e) => {
    e.preventDefault()

    try {
      submitBtn.disabled = true
      addNodeSpinner(submitBtn);
      restoreFormMessage(true)

      const payload = buildObject(e.target)
      payload.notify_owner = true // Always true
      payload.language = $Q("html").getAttribute("lang") ? $Q("html").getAttribute("lang") : 'fr' // Always true
      const { message } = await api.sendDataVintegaAPI({
        url: `/media-products/${form.dataset.productId}`,
        payload
      })

      renderFeedback(message)
      submitBtn.innerHTML = submitBtn.dataset.text;
      submitBtn.disabled = false

      if (payload.newslatter) {
        setTimeout(() => {
          sendKlaviyoForm()
        }, 1000)
      }
    } catch(error) {
      const { response: { data: { message } } } = error

      console.log("error response2", message);

      //renderFeedback(message[0])
      submitBtn.innerHTML = submitBtn.dataset.text;
      submitBtn.disabled = false
    }
  })
}

/**
 * On load event submit: Add preferred countries to phone input on more photos form
 */
window.addEventListener('load', async () => {
  const morePhotosTelInput = $Q("#js-plus-photo-modal .form__textfield-notlabel.coutry-custom input")
  if (!morePhotosTelInput) return;

  window.intlTelInput(morePhotosTelInput,{
    preferredCountries:['FR','GB','DE','IT']
  })
});
